<template>
  <div class="shoes-item" :class="myClasses">
    <div class="shoes-item__image" v-if="!selection">
      <img :src="data.images[0]" :alt="data.name" />
    </div>
    <div class="shoes-item__desc" v-if="!selection">
      <div class="shoes-item__desc__title">
        {{ data.name }}
      </div>
      <div class="shoes-item__desc__state">
        Disponible en {{ user.size }} EU
      </div>
      <div class="shoes-item__desc__date">Sortie le {{ data.date }}</div>
    </div>
    <img
      class="shoes-selection-image"
      :src="data.selection.image"
      :alt="data.name"
      v-if="selection"
    />
    <div class="shoes-selection row" v-if="selection">
      <div class="shoes-selection__image hidden-xs block-sm col-sm-5"></div>
      <div class="shoes-selection__desc col-xs-12 col-sm-7">
        <h3 class="shoes-selection__desc__title">
          <span class="brand">{{ data.selection.brand }}</span>
          <span class="model">{{ data.selection.model }}</span>
        </h3>
        <div class="shoes-selection__desc__date">Sortie le {{ data.date }}</div>
        <div class="shoes-selection__desc__state">
          Disponible dans votre pointure ({{ user.size }} EU)
        </div>
        <Button class="shoes-selection__desc__btn" primary
          >Je veux cette paire</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { firstCapitalize } from "@/plugins/helpers";
import Button from "@/components/Common/Button";
export default {
  name: "ShoesCard",
  components: {
    Button
  },
  props: {
    id: {
      type: String,
      required: true
    },
    selection: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {},
      myClasses: {
        "--selection": this.selection
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters({
      getShoeById: "getShoeById"
    })
  },
  methods: {
    firstCapitalize(string) {
      return firstCapitalize(string);
    }
  },
  beforeMount() {
    this.data = this.getShoeById(this.id);
  }
};
</script>

<style lang="scss">
.shoes-item {
  @media #{$md-and-up} {
    cursor: pointer;
  }
  box-shadow: get($shadows, "light");
  background: white;
  transition: all get($times, "fast");
  &:hover {
    transform: translateY(-0.5rem);
  }
  &__image {
    padding: 2rem 4rem;
    height: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    @media #{$md-and-up} {
      height: 25rem;
      padding: 3rem 4rem;
    }
    > img {
      max-width: 100%;
    }
  }
  &__desc {
    padding: 1rem 4rem 3rem;
    height: 12rem;
    color: get($colors, "grey");
    &__title {
      font-weight: bold;
      color: get($colors, "black");
    }
  }

  &.--selection {
    position: relative;
    margin-bottom: 4rem;
    border-radius: 1rem;
    @media #{$md-and-down} {
      overflow: hidden;
    }
    .shoes-selection {
      position: relative;
      padding: 4rem 3rem;
      border-radius: 1rem;
      overflow: hidden;
      @media #{$md-and-down} {
        padding-top: 30rem;
      }
      &:before {
        content: "";
        position: absolute;
        top: -56px;
        left: 0;
        background: get($theme, "gradient-1");
        // box-shadow: $shadow-color;
        width: 50rem;
        height: 50rem;
        z-index: 10;
        border-radius: 43%;
        transform: translate(40%, -60%);
        animation: drift 120s infinite ease;
        @media #{$md-and-down} {
          top: 3rem;
          left: 50%;
          width: 22rem;
          height: 22rem;
          border-radius: 100%;
          transform: translate(-50%, 0%);
          animation: none;
        }
      }
      &-image {
        max-width: 50%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(-10%, -55%) rotate(25deg);
        transform-origin: center;
        z-index: 20;
        @media #{$md-and-down} {
          max-width: 85%;
          top: calc(50% - 10rem);
          left: 50%;
          transform: translate(-50%, -50%) rotate(15deg);
        }
      }
      &__image {
        &:before {
          content: "";
          display: block;
          top: calc(50% - 15px);
          left: -30px;
          width: 250px;
          height: 10px;
          background: rgba(0, 0, 0, 0.19);
          position: absolute;
          z-index: 10;
          transform: rotate(25deg) translate(0, -50%);
          transform-origin: bottom left;
          box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.5);
        }
      }
      &__desc {
        &__title {
          font-size: 2.6rem;
          font-weight: bold;
          line-height: 1.5em;
          text-transform: uppercase;
          margin-bottom: 2rem;
          > span {
            display: block;
            letter-spacing: 0.8rem;
          }
          .brand {
            color: white;
            @include text-border(1px, get($colors, "black"));
          }
          .model {
            letter-spacing: 0.4rem;
          }
        }
        &__btn {
          margin-top: 2rem;
          @media #{$md-and-down} {
            display: none;
          }
        }
      }
    }
  }
}
</style>
